module.exports = __webpack_public_path__ + "static/img/m-dire2.949a95b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/m-dire2.jpg
// module id = TL9c
// module chunks = 1